import type { BacklogHttpResponse } from "../contracts/api/BacklogHttpResponse";
import type { BacklogResponseFile as BacklogResponseFileContract } from "../contracts/api/BacklogResponseFile";

export class BacklogResponseFile implements BacklogResponseFileContract {
	constructor(
		private options: {
			response: BacklogHttpResponse;
		},
	) {}
	text(): Promise<string> {
		return this.options.response.text();
	}
	json(): Promise<unknown> {
		return this.options.response.json();
	}
	blob(): Promise<Blob> {
		return this.options.response.blob();
	}
	arrayBuffer(): Promise<ArrayBuffer> {
		return this.options.response.arrayBuffer();
	}
}
